module.exports = "/_next/static/images/Cover@2x-9cbe45d7b9196dd44f8f12bef2ae3129.png";